import React, { Component } from "react";
import Router from "./Router";
// import { withLoader } from "./hoc";
import InlineSVG from "svg-inline-react";
import { Logo as LogoIcon, Toggle as ToggleIcon } from "./assets/svg";
import { Container, Flex } from "./ui";
import styled from "styled-components";
import { RollFromBottom } from "./ui/animations";
import { Link } from "react-router-dom";
import { Slider } from "react-burgers";
import { BurgerMenu } from "./components";

const Toggle = styled(InlineSVG)`
  z-index: 50;
`;
const Logo = styled(InlineSVG)`
  animation: ${RollFromBottom} 1.75s ease;
`;
class App extends Component {
  state = {
    burger: false
  };
  toggleBurger(burger) {
    if(burger !== undefined) {
      this.setState(prevState => ({ burger: burger }));
    } else {
      this.setState(prevState => ({ burger: !prevState.burger }));
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Router>
        <Container padding="5rem 2rem 0 2rem">
          <Flex
            alignItems="center"
            justifyContent="space-between"
            fillHeight
            burger={this.state.burger}
          >
            <Link to="/" id="logo">
              <Logo src={LogoIcon} />
            </Link>
            {/* <Toggle src={ToggleIcon} /> */}
            <Slider
              className="noclick"
              onClick={() => this.toggleBurger()}
              active={this.state.burger}
              width={22}
            />
            <BurgerMenu
              outsideClickIgnoreClass="noclick"
              toggleBurger={(open) => this.toggleBurger(open)}
              burger={this.state.burger}
            />
          </Flex>
        </Container>
      </Router>
    );
  }
}

// export default withLoader(3000)(App);
export default App;
